import { render, staticRenderFns } from "./mkbCheckbox.vue?vue&type=template&id=984cf908&"
import script from "./mkbCheckbox.vue?vue&type=script&lang=js&"
export * from "./mkbCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports